<div class="dialog">
  <!-- Local Survey Notifications -->
  @if (surveyPushNotifications && surveyPushNotifications.length) {
    <div class="separate-dialog-container">
      <header class="dialog__header">
        <h3 class="dialog__header__title">{{ 'Surveys' | translate }}</h3>
        <div class="dialog__header__action-buttons">
          <div (click)="closeDialog(PushNotificationType.Survey)" [tippy]="'Close this notification' | translate" class="dialog__header__action-buttons__button">
            <span>
              <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
            </span>
          </div>
        </div>
      </header>
      <div class="dialog__content">
        @for (notification of surveyPushNotifications | slice: 0 : 4; track notification) {
          <div class="push-notification-card">
            <div class="push-notification-card__image background-loading">
              <img alt="notification" appDefaultImage src="assets/images/push-notification-placeholder.png" />
            </div>
            <div class="push-notification-card__content">
              <h5 class="push-notification-card__content__title">{{ notification.surveyTitle | truncateText: 30 }}</h5>
              <p [innerHTML]="notification.survey.description | truncateText: 35" class="push-notification-card__content__description">{{ notification.survey.description | truncateText: 35 }}</p>
            </div>
          </div>
        }
      </div>
      <footer class="dialog__footer">
        <div class="dialog__footer__buttons">
          <app-button
            (click)="closeDialog(PushNotificationType.Survey, true)"
            [idleText]="'Read' | translate"
            [inlineStyle]="{ border: '1px solid var(--gray)' }"
            [tippy]="'Mark all notifications as read' | translate"
            backgroundColor="var(--white)"
            borderColor="var(--gray)"
            color="var(--dark-charcoal)"
            width="127px"
          ></app-button>
        </div>
      </footer>
    </div>
  }

  <!-- CRM Survey Notifications -->
  @if (crmSurveyNotifications && crmSurveyNotifications.length) {
    <div class="separate-dialog-container">
      <header class="dialog__header">
        <h3 class="dialog__header__title">{{ 'CRM Surveys' | translate }}</h3>
        <div class="dialog__header__action-buttons">
          <div (click)="closeDialog(PushNotificationType.CRMSurvey)" [tippy]="'Close this notification' | translate" class="dialog__header__action-buttons__button">
            <span>
              <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
            </span>
          </div>
        </div>
      </header>
      <div class="dialog__content">
        @for (notification of crmSurveyNotifications | slice: 0 : 4; track notification) {
          <div class="push-notification-card">
            <div class="push-notification-card__image background-loading">
              <img [appDefaultImage]="'assets/images/push-notification-placeholder.png'" [src]="notification.imageUrl" alt="notification" />
            </div>
            <div class="push-notification-card__content">
              <h5 class="push-notification-card__content__title">{{ notification.title | truncateText: 30 }}</h5>
              <p [innerHTML]="notification.description | truncateText: 35" class="push-notification-card__content__description">{{ notification.description | truncateText: 35 }}</p>
            </div>
            <footer class="push-notification-card__footer">
              <div class="push-notification-card__footer__avatar background-loading-tiny">
                <img [src]="notification.imageUrl" alt="" appDefaultImage />
              </div>
              <div class="push-notification-card__footer__user-details">
                <small>{{ notification.authorEmail }}</small>
                <p>{{ notification.createdAt | date: 'dd.MM.yyyy' }}</p>
              </div>
            </footer>
          </div>
        }
      </div>
      <footer class="dialog__footer">
        <div class="dialog__footer__buttons">
          <app-button
            (click)="closeDialog(PushNotificationType.CRMSurvey, true)"
            [idleText]="'Read' | translate"
            [inlineStyle]="{ border: '1px solid var(--gray)' }"
            [tippy]="'Mark all notifications as read' | translate"
            backgroundColor="var(--white)"
            borderColor="var(--gray)"
            color="var(--dark-charcoal)"
            width="127px"
          ></app-button>
        </div>
      </footer>
    </div>
  }

  <!-- CRM News Notifications -->
  @if (crmNewsNotifications && crmNewsNotifications.length) {
    <div class="separate-dialog-container">
      <header class="dialog__header">
        <h3 class="dialog__header__title">{{ 'CRM News' | translate }}</h3>
        <div class="dialog__header__action-buttons">
          <div (click)="closeDialog(PushNotificationType.CRMNews)" [tippy]="'Close this notification' | translate" class="dialog__header__action-buttons__button">
            <span>
              <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
            </span>
          </div>
        </div>
      </header>
      <div class="dialog__content">
        @for (notification of crmNewsNotifications | slice: 0 : 4; track notification) {
          <div class="push-notification-card">
            <div class="push-notification-card__image background-loading">
              <img [appDefaultImage]="'assets/images/push-notification-placeholder.png'" [src]="notification.imageUrl" alt="notification" />
            </div>
            <div class="push-notification-card__content">
              <h5 class="push-notification-card__content__title">{{ notification.title | truncateText: 30 }}</h5>
              <p [innerHTML]="notification.content | truncateText: 35" class="push-notification-card__content__description">{{ notification.content | truncateText: 35 }}</p>
            </div>
            <footer class="push-notification-card__footer">
              <div class="push-notification-card__footer__avatar background-loading-tiny">
                <img [src]="notification.authorImageUrl" alt="" appDefaultImage />
              </div>
              <div class="push-notification-card__footer__user-details">
                <small>{{ 'Author' | translate }}</small>
                <p>{{ notification.authorName }}</p>
              </div>
            </footer>
          </div>
        }
      </div>
      <footer class="dialog__footer">
        <div class="dialog__footer__buttons">
          <app-button
            (click)="closeDialog(PushNotificationType.CRMNews, true)"
            [idleText]="'Read' | translate"
            [inlineStyle]="{ border: '1px solid var(--gray)' }"
            [tippy]="'Mark all notifications as read' | translate"
            backgroundColor="var(--white)"
            borderColor="var(--gray)"
            color="var(--dark-charcoal)"
            width="127px"
          ></app-button>
        </div>
      </footer>
    </div>
  }
</div>
